import Operation from './Operation.js';

class MoveRollEvent extends Operation {
    constructor(mix, event, newStep ) {
        super(mix, event.getType());

        this.event = event;
        this.xTransform = newStep - this.event.step;
    }

    execute() {
        let nextEvent = this.mixByType.getNextEvent(this.event);
        if (nextEvent === undefined) {
            return;
        }
        let nextEventAfter = this.mixByType.getNextEvent(nextEvent);

        if (nextEventAfter === undefined ||
            nextEvent.step + this.xTransform <= nextEventAfter.step) {
            this.event.step += this.xTransform;
            nextEvent.step += this.xTransform;
            this.event.initialSubEvent.step += this.xTransform;
            this.event.subEvents.forEach(
                e => e.step += this.xTransform);
            nextEvent.initialSubEvent.step += this.xTransform;
            nextEvent.subEvents.forEach(
                e => e.step += this.xTransform);
        }
    }
}

export default MoveRollEvent;
